// extracted by mini-css-extract-plugin
module.exports = {"mobile":"360","tablet":"768","desktop":"1280","container":"_2HqoT","questionAnswer":"_3CHXO","number":"-S8l-","question":"hDSqM","text":"_3VSm9","answer":"_2yK7J","name":"_2Igur"};